var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"seasidetms_header_cart_link",attrs:{"to":_vm.lang ? '/' + _vm.lang + '/cart' : '/cart'}},[_c('span',{staticClass:"count_wrap seasidetms_icon_custom_cart_1"},[_c('span',{staticClass:"count seasidetms_dynamic_cart_count"},[_vm._v(_vm._s(_vm.cart.qty))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }